import * as React from "react";
import Component from "../../AbstractComponent";
import { PromptDialog } from "./PromptDialog";
import Constants from "../../../Action/Constants";
import { PageTransition } from "../Spinner/PageTransition";
import NewChargesList from "../Charge/NewChargesList";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';

export class CoachNewSettleCharge extends Component {
  protected timer;

  public defaultState = {
    isOpen: false,
    step: this.props.step ? this.props.step : 1,
    isSaving: false,
    isSaveButtonClicked: false,
    activeStep: 0,
    skipped: new Set(),
    hasModifiedData: false,
    openLeavePrompt: false,
    errorFields: null,
    isClosePreprocessDialogOpen: false,
    selectedSecondChargeToSettleId: null,
    newCharge: null
  };

  public state = {
    ...this.defaultState
  };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== this.state.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen,
        step: nextProps.step ? nextProps.step : this.state.step
      });
    }
  }

  public clearState = () => {
    this.setState({
      ...this.defaultState
    })
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public onCloseCoach = () => {
    setTimeout(() => {this.clearState()}, 100);
    this.clearBackEndErrors();

    if (this.props.onCloseCoach) {
      this.props.onCloseCoach.call(this);
    }
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();
    if (activeStep === steps.length - 1) { // it is last step
      this.onCloseCoach();
          
      if (typeof this.props.updateCharge === "function") {
        return this.props.updateCharge.call(this, this.state?.newCharge)
      }
    } else {
      switch (activeStep) {
        case 0:
          return this.startStepFirst();
        case 1:
          return this.plusOneStep();
      }
    }
  };

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [this.trans("launch-panel-settle-charge"), this.trans("coach/newtenant-step/second-title")];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
      </div>
    )
  }

  // Steppers components content

  public firstStepDetails = () => {
    return (
      <div>
        <div className="charges-section-wrapper">
          <NewChargesList
            {...this.props}
            firstChargeToSettle={this.props.charge}
            hideTotalAmount={true}
            isSettleProcess={true}
            updateParentState={this.updateParentState}
          />
        </div>
      </div>   
    );         
  }

  public secondStepDetails = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("coach/settlecharge-step/second-info")}
        </div> 
      </div>
    );
  }

  //Funcionality for steps
  public startStepFirst = () => {
    return this.coachStartStepFirst();
  }

  public startStepSecond = () => {
    return this.coachStartStepSecond();
  }

  //Methods for step logic
  public coachStartStepFirst = () => {
    if (!this.state.selectedSecondChargeToSettleId) {
      this.onCloseCoach();
    } else {
      this.settleWithCharge(this.state.selectedSecondChargeToSettleId);
    }
  }

  public coachStartStepSecond = () => {
    this.plusOneStep();
  }

  public updateParentState = (state) => {
    if (typeof state === "object" && state !== null) {
      this.setState({
        ...state
      });
    }
  }

  //Methods
  public settleWithCharge = (selectedChargeId: number) => {
    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_SETTLE_START,
        payload: {
          id: this.props.charge?.id,
          existedChargeId: selectedChargeId
        },
        onSuccess: (newCharge) => {
          this.setState({
            activeStep: 1,
            isSaving: false,
            newCharge
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public renderContent = () => {
    const steps = this.getSteps();
    const { activeStep } = this.state;

    return (
      <div className="stepper-wrapper">
        <div className="stepper-container">
        { activeStep !== steps.length &&
          <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              const props = {};
              const labelProps = {};
              return (
                <Step key={label} {...props}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        }
        <div>
          <div className="step-content-wrapper step-scrollable-content first-invoice-coach">
            {this.getStepContent(activeStep)}
          </div>
        </div>
      </div>
      { activeStep !== steps.length &&
        <div className={`step-content-button-wrapper button-container ${activeStep === steps.length - 1 ? "without-cancel" : ""}`}>
          {
            activeStep !== steps.length - 1 &&
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                this.setState({
                  isClosePreprocessDialogOpen: true
                })
              }}
              className="cancel-button"
            >
              {this.trans("dialog-button/close")}
            </Button>
          }

          <div>
            {
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleNext}
                disabled={activeStep === 0 && !this.state.selectedSecondChargeToSettleId}
              >
              {activeStep === steps.length - 1 ? this.trans("button-close") : this.trans("button-settle")}
            </Button>
            }
          </div>
        </div>
      }
    </div>
    )
  }

  public render() {
    return (
      <div>
        <Dialog
          className={`dialog dialog-window dialog-assistant coach-dialog coach-settle-charge has-button-padding ${this.props.innerDialogClasses}`}
          open={this.state.isOpen}
          onClose={this.onCloseCoach}
          disableBackdropClick={true}
        >
          <DialogContent>
            {this.renderContent()}
          </DialogContent>
        </Dialog>

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention")}
          content={
            <div style={{width: "calc(100% - 65px)"}}>
            {this.trans("are-you-sure")
            }
            </div>
          }
          openLeavePrompt={this.state.isClosePreprocessDialogOpen}
          onClose={this.closePreprocessDilaogOpen}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          hideCross={true}
          actions={
            [(
              <Button
              key="modal-cancel-btn"
              color="primary"
              onClick={this.closePreprocessDilaogOpen}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-no")}
              </Button>
            ),
            (
              <Button
              key="modal-add-btn"
              variant="contained"
              color="primary"
              onClick={this.onCloseCoach}
              style={{height: "34px", width: "auto" }}
              >
                {this.trans("label-yes")}
              </Button>
            )]
          }
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}